import { useEffect, useMemo, useState } from "react";
import MaterialReactTableWithSearch from "../../../components/MaterialReactTable/MaterialReactTableWithSearch";
import { useData } from "../../../context/DataContext";
import { APP_ROUTES } from "../../../config/appRoutes";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
    Box, IconButton, Tooltip, Card, CardContent, Grid, Divider, Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
} from "@mui/material";
import { deleteSoilReport } from "../../../context/createAPI"
import SoilVillageDetailsModal from "./SoilVillageDetailsModal";
import UpdateIcon from '@mui/icons-material/Update';
import SingleSelect from "../../../components/Selections/singleSelect";
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";


function SoilReportHistory() {
    const navigate = useNavigate()
    const { levels = [], years = [], soilReports = [], villageGroups = [], user = {}, handleSoilReports, user_client_id } = useData();

    const villageLevelOptions = [{ value: 1, label: user?.level_id === 1 ? "Villages" : "Groups" }, ...user_client_id === 2 ? [] : [{ value: 2, label: "Farmers" }]]

    const [state, setState] = useState({
        selectedLevelType: "",
        selectedYearId: +years[0]?.value ?? 1,
        selectedVillageWiseOption: 1,
        yearBasedSoilData: [],
        filteredSoilReportData: [],
        groupsArray: [],
        villagesArray: [],
        selected_village_ids: [],
        villageDetailsModal: false,
        villageDetailsRowData: []

    });

    const soilReportColumns = useMemo(() => {
        const baseColumns = [
            {
                accessorKey: "year",
                header: "Year",
                size: 80, minSize: 50
            },
            {
                accessorKey: "soil_type",
                header: "Soil Type",
                size: 80, minSize: 50,
                accessorFn: (row) => row.soil_type ?? "-",
            },
            {
                accessorKey: "survey_no",
                header: "Survey No",
                size: 80, minSize: 50,
                accessorFn: (row) => row.survey_no ?? "-",
            },
            {
                accessorKey: "crop_type",
                header: "Crops Type",
                size: 80, minSize: 50,
                accessorFn: (row) => row.crop_type ?? "-",
            },
            {
                accessorKey: "ph",
                header: "pH",
                size: 80, minSize: 50
            },
            {
                accessorKey: "ec",
                header: "EC",
                size: 80, minSize: 50
            },
            {
                accessorKey: "oc",
                header: "OC",
                size: 80, minSize: 50
            },
            {
                accessorKey: "n",
                header: "N",
                size: 80, minSize: 50
            },
            {
                accessorKey: "p",
                header: "P",
                size: 80, minSize: 50
            },
            {
                accessorKey: "k",
                header: "K",
                size: 80, minSize: 50
            },
            {
                accessorKey: "clay_content",
                header: "Clay Content",
                size: 80, minSize: 50,
                accessorFn: (row) => row.clay_content ?? "-",
            },
            {
                accessorKey: "cec",
                header: "CEC",
                size: 80, minSize: 50,
                accessorFn: (row) => row.cec ?? "-",
            }
        ];
        let additionalColumns = [];
        if (state.selectedVillageWiseOption === 1) {
            additionalColumns = [
                {
                    accessorFn: (row, index) => index + 1,
                    header: 'SNO',
                    id: 'id',
                    size: 80, minSize: 50,
                    enableGlobalFilter: false,
                },
                {
                    accessorKey: "village_name",
                    header: "Village Name",
                    size: 80, minSize: 50
                },
            ];
        } else if (state.selectedVillageWiseOption === 2) {
            additionalColumns = [
                {
                    accessorFn: (row, index) => index + 1,
                    header: 'SNO',
                    id: 'id',
                    size: 80, minSize: 50,
                    enableGlobalFilter: false,
                },
                {
                    accessorKey: "village_name",
                    header: "Village Name",
                },
                {
                    accessorKey: "farmer_name",
                    header: "Farmer Name",
                },
                {
                    accessorKey: "farmer_mobile",
                    header: "Farmer Mobile",
                },
            ];
        }
        if (state.selectedLevelType === 2) {
            additionalColumns = [
                {
                    accessorFn: (row, index) => index + 1,
                    header: 'SNO',
                    id: 'id',
                    size: 80, minSize: 50,
                    enableGlobalFilter: false,
                },
                {
                    accessorKey: "group_name",
                    header: "Group Name"
                },
                {
                    accessorKey: "farmer_name",
                    header: "Farmer Name"
                },
                {
                    accessorKey: "farmer_mobile",
                    header: "Farmer Mobile"
                }
            ];
        }
        if (state.selectedLevelType === 1 && state.selectedVillageWiseOption === 1) {
            return [
                ...additionalColumns,
            ];
        } else {
            return [
                ...additionalColumns,
                ...baseColumns,
            ];
        }
    }, [state.selectedVillageWiseOption, state.selectedLevelType]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            selectedLevelType: user_client_id === 1 ? 1 : 2
        }));
    }, [user_client_id]);

    useEffect(() => {
        const yearsSoilData = soilReports.filter((item) => +item.year_id === +state.selectedYearId)
        if (user.level_id === 2) {
            console.log("i am header all 9999999");

            const data = yearsSoilData.filter((item) => +item.report_level_id === 2);
            setState((prevState) => ({
                ...prevState,
                selectedLevelType: 2,
                filteredSoilReportData: data,
                yearBasedSoilData: yearsSoilData
            }))
        } else if (state.selectedLevelType === 1 && state.selectedVillageWiseOption === 1) {
            console.log("i am header all Village");
            const data = yearsSoilData.filter((item) => item.report_level_id === 1 && item.year_id === +state.selectedYearId);
            const villageData = data.filter(item => item.ff_group_id === null && item.farmer_id === null).reduce((unique, item) => {
                if (!unique.some(uniqueItem => uniqueItem.village_id === item.village_id)) {
                    unique.push(item);
                }
                return unique;
            }, []);

            console.log("1212", villageData);
            setState((prevState) => ({
                ...prevState,
                filteredSoilReportData: villageData,
                yearBasedSoilData: yearsSoilData
            }))
        } else if (state.selectedLevelType === 1 && state.selectedVillageWiseOption === 2) {
            console.log("i am header all Farmer");
            const data = yearsSoilData.filter((item) => +item.report_level_id === 1 && +item.year_id === +state.selectedYearId);
            const villageData = data.filter(item => item.village_id !== null && item.farmer_id !== null);
            setState((prevState) => ({
                ...prevState,
                filteredSoilReportData: villageData,
                yearBasedSoilData: yearsSoilData
            }))
        } else if (state.selectedLevelType === 2) {
            console.log("i am header all Group");
            const data = yearsSoilData.filter((item) => item.report_level_id === 2 && item.year_id === +state.selectedYearId);
            setState((prevState) => ({
                ...prevState,
                filteredSoilReportData: data,
                yearBasedSoilData: data,
            }))
        }
    }, [soilReports, state.selectedYearId, state.selectedLevelType, state.selectedVillageWiseOption, user.level_id]);

    useEffect(() => {
        if (villageGroups && villageGroups.length > 0) {
            let villageData = [];
            let groupData = [];
            // const villageGroupData = villageGroups[3].data;
            const villageGroupData = villageGroups?.[3]?.data || [];

            if (user.level_id === 1) {
                villageData = villageGroupData.filter((item) => item.village_id !== "").map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
            } else if (user.level_id === 2) {
                groupData = villageGroupData.map(groupData => ({
                    value: groupData.group_id,
                    label: groupData.Groups
                }))
            } else {
                villageData = villageGroupData.filter((item) => item.village_id !== "").map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
            }
            setState((prevState) => ({
                ...prevState,
                groupsArray: groupData,
                villagesArray: villageData,
                selected_village_ids: villageData
            }));

        }
    }, [villageGroups, user.level_id]);

    const handleVillageWiseSelectionChange = (level) => {
        const data = state.yearBasedSoilData.filter((item) => item.report_level_id === 1)
        let villagefarmerData = []
        if (level === 1) {
            villagefarmerData = data.filter((item) => item.ff_group_id === null && item.farmer_id === null).reduce((unique, item) => {
                if (!unique.some(uniqueItem => uniqueItem.village_id === item.village_id)) {
                    unique.push(item);
                }
                return unique;
            }, []);
        } else {
            villagefarmerData = data.filter((item) => item.village_id !== null && item.farmer_id !== null)
        }

        setState(prevState => ({ ...prevState, selectedVillageWiseOption: level, filteredSoilReportData: villagefarmerData }))
    };
    const renderRowActions = ({ row }) => (
        <Box sx={{ display: "flex", gap: "1rem" }}>
            {user.level_id !== 2 && state.selectedVillageWiseOption === 1 && (
                <Tooltip title="View Details">
                    <IconButton>
                        <VisibilityOutlinedIcon sx={{ color: "var(--secondary)" }} onClick={() => handleView(row)} />
                    </IconButton>
                </Tooltip>
            )}
            {
                user.user_level_id === 4 && (
                    <>
                        <Tooltip title="Edit">
                            <IconButton>
                                <UpdateIcon sx={{ color: "var(--success)" }} onClick={() => handleUpdate(row)} />
                            </IconButton>
                        </Tooltip>
                        {/*           <Tooltip title="Delete">
                            <IconButton color="error">
                                <DeleteOutlineIcon onClick={() => handleDelete(row)} />
                            </IconButton>
                        </Tooltip>*/}
                    </>
                )
            }

        </Box>
    );
    const handleView = (row) => setState((prevState) => ({ ...prevState, villageDetailsModal: true, villageDetailsRowData: row.original }));

    const handleClose = () => setState((prevState) => ({ ...prevState, villageDetailsModal: false }));

    const handleUpdate = (row) => {
        const rowData = row.original
        if (state.selectedLevelType === 1 && state.selectedVillageWiseOption === 1) {
            navigate(`${APP_ROUTES.SOILREPORT.HISTORY_ROUTES.VILLAGEEDIT}`, { state: { rowData: rowData, stateData: state } });
        } else {
            navigate(`${APP_ROUTES.SOILREPORT.HISTORY_ROUTES.EDIT}`, { state: { rowData: rowData, stateData: state } });
        }
    }
    const handleDelete = async (row) => {

        const confirmed = window.confirm("Are You Sure You Want to Delete?");
        if (!confirmed) {
            return;
        }

        try {
            const deleteApi = await deleteSoilReport(
                user.level_id !== 2 && state.selectedVillageWiseOption === 1
                    ? {
                        village_id: row.original.village_id,
                        target_year: row.original.year_id,
                        id: row.original.id,
                    }
                    : {
                        id: row.original.id,
                        village_id: row.original.village_id,
                        target_year: row.original.year_id
                    }
            );

            if (deleteApi.statusCode === 200) {
                handleSoilReports();
                setState((prevState) => ({
                    ...prevState,
                    selectedVillageWiseOption: 1
                }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleInputChange = (name, value) => {
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleMultiselectVillagechange = (name, selectedOption = []) => {

        if (selectedOption.length > 0) {
            const selectedVillageIds = selectedOption.map(option => option.value);
            const villageSoilReport = state.yearBasedSoilData.filter((a) => a.report_level_id === 1 && a.ff_group_id === null && a.farmer_id === null)

            const filteredTableData = villageSoilReport
                .filter(item => selectedVillageIds.includes(item.village_id.toString()))
                .reduce((unique, item) => {
                    // Check if the item is already in the unique array
                    if (!unique.some(uniqueItem => uniqueItem.village_id === item.village_id)) {
                        unique.push(item); // Add it if it's unique
                    }
                    return unique;
                }, []);

            setState(prevState => ({
                ...prevState,
                selected_village_ids: selectedOption,
                filteredSoilReportData: filteredTableData
            }));

        } else {
            setState(prevState => ({
                ...prevState,
                selected_village_ids: [],
                filteredSoilReportData: []
            }));
        }
    };

    const enableRowActions = () => {
        if (user.user_level_id === 4) {
            return true; // Admin user can always have actions enabled
        }
        return (user.user_level_id === 1 || user.user_level_id === 2 || user.user_level_id === 3) && state.selectedLevelType === 1 && state.selectedVillageWiseOption === 1;
    };

    return (
        <>
            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

            <Box mt={1}>
                <Card elevation={6}>
                    <CardContent>
                        <Box sx={{ backgroundColor: "#fff", p: 0.5 }}>
                            {
                                state.selectedLevelType === 1 ? (
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            name="radioOption"
                                            value={state.selectedVillageWiseOption}
                                            onChange={(e) =>
                                                handleVillageWiseSelectionChange(Number(e.target.value))
                                            }
                                        >
                                            {villageLevelOptions.length > 0 ? (
                                                villageLevelOptions.map((item) => (
                                                    <FormControlLabel
                                                        key={item.value}
                                                        value={item.value}
                                                        control={<Radio color="success" />}
                                                        label={item.label}
                                                        sx={{ mr: 3 }}
                                                    />
                                                ))
                                            ) : (
                                                <Box sx={{ fontSize: 14 }}>Level Are Not Found</Box>
                                            )}
                                        </RadioGroup>
                                    </FormControl>
                                ) : (
                                    <FormControl>
                                        <RadioGroup row name="radioOption" value="farmer">
                                            <FormControlLabel
                                                value="farmer"
                                                control={<Radio color="success" />}
                                                label="Farmer"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                )
                            }
                        </Box>
                        <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

                        <Box sx={{ p: 2 }}>
                            <Grid container spacing={1}>
                                {
                                    [{ id: 1, name: "selectedYearId", label: "Select year", value: state.selectedYearId, options: years },
                                    ...user?.user_level_id !== 1 && user?.user_level_id !== 2 ? [] : [{ id: 2, name: "selectedLevelType", label: "Select Level", value: state.selectedLevelType, options: levels }],
                                    ...state.selectedLevelType === 1 && state.selectedVillageWiseOption === 1 ? [{ id: 3, name: "selected_village_ids", label: "Select Villages", value: state.selected_village_ids, options: state.villagesArray }] : [],
                                    ].map((field) => (
                                        <Grid item size={{ xs: 12, md: 3 }}>
                                            {
                                                field.id === 3 ? (
                                                    <MultiSelectWithAll
                                                        name={field.name}
                                                        label={field.label}
                                                        // options={field.options}
                                                        options={field.options || []}
                                                        value={state[field.name] || []}
                                                        onChange={handleMultiselectVillagechange}
                                                    />
                                                ) : (
                                                    <SingleSelect
                                                        name={field.name}
                                                        label={field.label}
                                                        // options={field.options}
                                                        options={field.options || []}
                                                        value={field.value}
                                                        onChange={handleInputChange}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </Box>

                        <Grid container spacing={1}>
                            <Grid item size={{ xs: 12, md: 12 }}>
                                <MaterialReactTableWithSearch
                                    data={state.filteredSoilReportData}
                                    columns={soilReportColumns}
                                    enableRowActions={enableRowActions()}
                                    renderRowActions={(props) => {
                                        return renderRowActions({ ...props });
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
            {state.villageDetailsModal && <SoilVillageDetailsModal handleClose={handleClose} show rowData={state} />}
        </>
    )
};
export default SoilReportHistory;